import React, { useState, useEffect } from "react";
import { supabase } from "../../supabase";
import Layout from "../../components/admin/Layout";
import AdminList from "../../components/admin/AdminList";
import { ICON_PATHS } from "../../constants/iconPaths";
import IconButton from "../../components/admin/IconButton";
import styles from "./Stadium24.module.css";
import { Helmet } from "react-helmet";

function Stadium24Page() {
  const [stadiums, setStadiums] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchStadiums();
  }, []);

  const fetchStadiums = async () => {
    try {
      setIsLoading(true);
      const { data, error } = await supabase
        .from("stadium24")
        .select("*")
        .order("id", { ascending: true });

      if (error) throw error;
      
      // 검색을 위한 원본 name은 유지하면서 표시용 데이터 추가
      const processedData = data.map(stadium => ({
        ...stadium,
        _searchName: stadium.name, // 검색용 필드 추가
        name: (
          <div className={styles.nameCell}>
            <span>{stadium.name}</span>
            <IconButton
              icon={ICON_PATHS.externalLink}
              onClick={(e) => {
                e.stopPropagation();
                window.open(`/stadium24/${stadium.id}${stadium.code}`, '_blank');
              }}
              size="small"
            />
          </div>
        )
      }));

      setStadiums(processedData);
    } catch (error) {
      console.error("Error fetching stadiums:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const headers = [
    { key: "id", label: "ID" },
    { key: "_searchName", label: "구장명", renderKey: "name" }, // 검색은 _searchName으로, 표시는 name으로
    { key: "match_all", label: "총 매치 수" },
    { key: "user_all", label: "총 방문자 수" },
    { key: "user_unique_all", label: "순 방문자 수" },
  ];

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Layout>
      <Helmet>
        <title>어드민:스타디움24</title>
      </Helmet>
      <div className={styles.container}>
        <h1>스타디움24 관리</h1>
        <AdminList
          headers={headers}
          data={stadiums}
          onRowClick={() => {}}
        />
      </div>
    </Layout>
  );
}

export default Stadium24Page; 